export var WidgetPosition;
(function (WidgetPosition) {
    WidgetPosition["Unknown"] = "Unknown";
    WidgetPosition["LeftBottom"] = "LeftBottom";
    WidgetPosition["RightBottom"] = "RightBottom";
    WidgetPosition["CenterBottom"] = "CenterBottom";
    WidgetPosition["Modal"] = "Modal";
})(WidgetPosition || (WidgetPosition = {}));
